@use '@lib/assets/styles/main.scss' as *;

.container {
  border: 1px solid $gray200;
  border-radius: 6px;
  overflow: hidden;
}

.tabsContainer {
  border-bottom: 1px solid $gray100;
  padding: 6px 0 0;
}

.tabBar {
  margin-bottom: 0;
}

.content {
  background: $gray10;
  padding: 12px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
